// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__PP5bO","balanceDisclaimer":"posDashboard_balanceDisclaimer__2E2GM"};